export const PageList = [
  {
    title: "Get help with repairs",
    path: "/repairs",
    highlight: true,
    feature: true,
    col: 1,
  },
  {
    title: "Report your rogue landlord",
    path: "/report",
    highlight: true,
    feature: true,
    col: 1,
  },
  {
    title: "More about the Campaign",
    path: "/campaign",
    highlight: false,
    feature: true,
    col: 2,
  },
  {
    title: "Join Living Rent",
    path: "https://www.livingrent.org/join",
    highlight: false,
    feature: true,
    col: 1,
  },

  {
    title: "The Repairing Standard",
    path: "/repairingstandard",
    highlight: false,
    feature: false,
    col: 2,
  },
  {
    title: "The 'Fit and Proper Person' test",
    path: "/fpp",
    highlight: false,
    feature: false,
    col: 2,
  },
  {
    title: "The Council's powers",
    path: "/powers",
    highlight: false,
    feature: false,
    col: 2,
  },
];
